import { useLdFlag } from './useLdFlag'
import { ExplicitWindowContextScope } from '@highlight/common'

/**
 * Returns the default window scope based on LaunchDarkly flag.
 * When the flag is enabled, defaults to 'full' context.
 * When disabled, defaults to 'visible' context.
 */
export const useDefaultWindowScope = (): ExplicitWindowContextScope => {
  const defaultToFullContext = useLdFlag<boolean>('default-to-full-window-context', true)
  return defaultToFullContext ? 'full' : 'visible'
}
